/* ==================================================================
 *  B2B "Zobacz ceny" acilir menusu — LaBalancia
 *  Ayrinti: theme-degisiklikleri.md
 *
 *  ⚠️ MENU <body>'YE TASINIYOR (portal deseni). Sebep OLCULDU
 *  30.08.2026, ana sayfa urun izgarasinda; menunun atalari:
 *
 *    div.product-item.animation        transform + opacity: 0
 *    div.featured-...__products        transform (Swiper)
 *    div.section                       position: relative; z-index: 0
 *
 *  Ucu de YIGILMA BAGLAMI kuruyor. Sonuclari:
 *    1. z-index kapsayicinin ICINDE calisir — 2147483000 yazsak bile
 *       menu, sonraki bolumun altinda kalir. Olculdu: kaliyordu.
 *    2. `position: fixed` transform'lu bir ata varsa EKRANA gore
 *       degil O ATAYA gore konumlanir. Olculdu: tetikleyici sol 344
 *       iken menu sol 597 cikiyordu — 253 px kayma.
 *
 *  z-index yukseltmek IKISINI DE cozmez. Tek cozum menuyu yigilma
 *  baglaminin disina, <body>'nin dogrudan cocuguna tasimak.
 *
 *  ⚠️ MENU ARTIK KOKUN COCUGU DEGIL. Bu yuzden:
 *    - acik/kapali durumu MENUNUN kendi `data-open` niteliginde
 *      (CSS artik torun seciciyle calisamaz)
 *    - `kok.contains(...)` kontrollerine menu AYRICA sorulmali
 *    - disari-tiklama kontrolu menuyu da hesaba katmali
 *  Bu uc yer atlanirsa menu ya hic acilmaz ya da kapanmaz.
 *
 *  ⚠️ TEK DINLEYICI, OLAY DEVRI. Koleksiyonda 40 kart var; sonradan
 *  gelenler (sonsuz kaydirma, hizli goruntuleme) de kapsansin diye
 *  dinleyiciler `document` uzerinde.
 *
 *  ⚠️ CIHAZ AYRIMI `pointer`/`hover` ile, GENISLIKLE DEGIL.
 *
 *  🔴 IC KAYDIRMA — olculdu 01.09.2026, 6.1.0 onizlemesi.
 *
 *  `scroll` olayi BUBBLE ETMEZ. Dinleyici yalnizca `window` uzerinde
 *  oldugu icin sepet cekmecesinin KENDI kaydirmasi hic ulasmiyordu:
 *
 *    cekmece ici 400px kaydirildi
 *      tetikleyici ust  190  ->  -210   (ekrandan cikti)
 *      menu        ust  230  ->   230   (YERINDE KALDI)
 *      dikeyFark     6  ->  406
 *      window'a gelen scroll olayi: 0
 *
 *  Ekranda menu, alakasiz bir urun satirinin uzerinde "ustte ve
 *  solda" duruyordu — bildirilen belirti tam buydu.
 *
 *  ⚠️ WINDOW KAYDIRMASI ZATEN DOGRU CALISIYORDU. Ilk olcumde
 *  bozuk gorundu ama o bir OLCUM YAPAYLIGIYDI: otomasyondan cagrilan
 *  `window.scrollBy()` bu ortamda scroll olayi uretmiyor. Gercek fare
 *  tekerlegiyle olay geliyor ve menu takip ediyor (dikeyFark 5.7).
 *
 *  ⚠️ Kapsam: sepet cekmecesi (`form.quick-cart__form`) TEK ic
 *  kaydirma kabi. Olculdu: urun sayfasindaki 12 ve koleksiyondaki
 *  tetikleyicilerin HICBIRINDE kaydirilabilir ata yok.
 *
 *  ⚠️ Yeniden cizimde (miktar degistir) sorun YOK — menu temiz
 *  kapaniyor, `body`de oksuz menu birikmiyor (olculdu: 1 -> 1).
 * ================================================================== */

(function () {
  'use strict';

  var OPEN = 'data-open';
  var ince = window.matchMedia('(hover: hover) and (pointer: fine)');
  var acik = null;
  var kapatmaZamani = null;
  var sayac = 0;

  function menuOf(kok) { return kok && kok._b2bMenu; }
  function trigOf(kok) { return kok && kok.querySelector('[data-b2b-cta-trigger]'); }

  /* Kok VEYA ona ait menu iceriyor mu? Menu artik kokun cocugu degil. */
  function icinde(kok, node) {
    if (!kok || !node) return false;
    var m = menuOf(kok);
    return kok.contains(node) || (m && m.contains(node));
  }

  function hazirla(kok) {
    if (kok.hasAttribute('data-b2b-ready')) return;
    kok.setAttribute('data-b2b-ready', '');
    var menu = kok.querySelector('[data-b2b-cta-menu]');
    var trig = trigOf(kok);
    if (!menu || !trig) return;

    sayac += 1;
    var id = 'b2b-cta-menu-' + sayac;
    menu.id = id;
    trig.setAttribute('aria-controls', id);
    trig.setAttribute('aria-haspopup', 'true');
    trig.setAttribute('aria-expanded', 'false');

    // PORTAL: yigilma baglamindan cikar.
    menu.setAttribute(OPEN, 'false');
    document.body.appendChild(menu);
    kok._b2bMenu = menu;
    menu._b2bKok = kok;
  }

  /* En yakin KAYDIRILABILIR ata — menunun capasini kirpan kutu.
   *
   * ⚠️ `overflow` DEGERI TEK BASINA YETMEZ: sepet cekmecesindeki
   * `form.quick-cart__form` tek urunle `overflow-y: auto` ama
   * `scrollHeight === clientHeight` — kaydirilamiyor. Gercekten
   * TASAN kutu araniyor.
   *
   * ⚠️ `body`/`documentElement`te duruyor: belge kaydirmasini
   * `window` dinleyicisi zaten karsiliyor. */
  function kayanAta(el) {
    var p = el && el.parentElement;
    while (p && p !== document.body && p !== document.documentElement) {
      var cs = getComputedStyle(p);
      if ((p.scrollHeight > p.clientHeight + 1 && /auto|scroll/.test(cs.overflowY))
        || (p.scrollWidth > p.clientWidth + 1 && /auto|scroll/.test(cs.overflowX))) return p;
      p = p.parentElement;
    }
    return null;
  }

  /* Menuyu tetikleyicinin altina, ORTALI yerlestir.
   * ⚠️ Ekran kenarina tasarsa ortalama bozulur ve menu iceri cekilir. */
  function yerlestir(kok) {
    var menu = menuOf(kok);
    var trig = trigOf(kok);
    if (!menu || !trig) return;

    var t = trig.getBoundingClientRect();
    var bosluk = 6;
    var kenar = 12;

    /* 🔴 TETIKLEYICI KABIN DISINA CIKTIYSA MENUYU KAPAT.
     *
     * Yalnizca "takip et" demek yetmiyor: tetikleyici cekmecenin
     * gorunur alanindan cikinca menu ekranin tepesine yapisiyor ve
     * ALAKASIZ bir satirin uzerinde duruyor — bildirilen belirtinin
     * ta kendisi. Capasi olmayan menunun dogru yeri yoktur.
     *
     * ⚠️ Acilis aninda CALISMAZ: `ac()` once `yerlestir()` cagirip
     * SONRA `acik = kok` yaziyor. Kullanicinin az once tikladigi
     * tetikleyici zaten gorunur; burada kapatmak menuyu hic
     * acilmamis gosterirdi. */
    var kap = kayanAta(trig);
    if (kap) {
      var kr2 = kap.getBoundingClientRect();
      if (t.bottom <= kr2.top || t.top >= kr2.bottom
        || t.right <= kr2.left || t.left >= kr2.right) {
        if (acik === kok) kapat(kok);
        return;
      }
    }

    // ⚠️ GENISLIK ICERIGE GORE. Kart genisligine ZORLANMIYOR — kartin
    // genisligi yalnizca UST SINIR. Zorlanınca menu gereksiz genis
    // duruyordu ve metin sariyordu.
    var kart = kok.closest('.product-item, .product-card-mini, .cart__form-item, .quick-cart__item') || kok;
    var kr = kart.getBoundingClientRect();
    var ustSinir = Math.min(
      Math.max(kr.width, 200),
      window.innerWidth - kenar * 2
    );
    menu.style.maxWidth = Math.round(ustSinir) + 'px';

    // Olcmek icin gorunur olmali; display:none olanin genisligi 0.
    var onceki = menu.getAttribute(OPEN);
    menu.setAttribute(OPEN, 'true');
    var m = menu.getBoundingClientRect();
    if (onceki !== 'true') menu.setAttribute(OPEN, onceki || 'false');

    // ⚠️ VARSAYILAN ORTALI: menu merkezi = tetikleyici merkezi. Buton
    // kartta ortada duruyor; sol kenara hizali menu yamuk gorunuyordu.
    var sol = t.left + t.width / 2 - m.width / 2;
    // Ekran kenari ortalamayi EZER — tasmaktansa hizalama bozulur.
    if (sol + m.width > window.innerWidth - kenar) sol = window.innerWidth - kenar - m.width;
    if (sol < kenar) sol = kenar;

    var ust = t.bottom + bosluk;
    if (ust + m.height > window.innerHeight - kenar && t.top - bosluk - m.height > kenar) {
      ust = t.top - bosluk - m.height;
    }

    menu.style.left = Math.round(sol) + 'px';
    menu.style.top = Math.round(ust) + 'px';
  }

  /* @param {string} nasil 'hover' | 'click' — menunun NASIL acildigi.
   *
   * 🔴 BU AYRIM OLMADAN MENU KULLANILAMIYORDU (olculdu 01.09.2026).
   * Masaustunde `pointerover` menuyu aciyor, kullanicinin hemen ardindan
   * yaptigi tik `click` isleyicisinde ACIK gorup KAPATIYORDU:
   *
   *     pointerover -> true      imlec deginde acildi
   *     click       -> false     ardindan gelen tik kapatti
   *
   * Butona basan kullanici menuyu HIC goremiyordu. Olculdu: sepet
   * cekmecesinde de, urun kartinda da birebir ayni.
   *
   * ⚠️ DOKUNMATIKTE HATA YOKTU — orada `ince.matches` false, hover
   * olayi hic gelmiyor, tik tek yol. Olculdu: 1. dokunus acti,
   * 2. dokunus kapatti. O dal DEGISMEDI.
   */
  function ac(kok, nasil) {
    if (acik && acik !== kok) kapat(acik);
    clearTimeout(kapatmaZamani);
    yerlestir(kok);
    var menu = menuOf(kok);
    if (menu) menu.setAttribute(OPEN, 'true');
    kok.setAttribute(OPEN, 'true');
    // ⚠️ `click` HOVER'I EZER, tersi OLMAZ: imlec zaten acmis bir
    // menuye tiklamak onu KALICI yapar. Ezme ters yonde olsaydi
    // tiklanarak acilan menu, imlec cikinca kendiliginden kapanirdi.
    if (nasil === 'click' || !kok._b2bNasil) kok._b2bNasil = nasil || 'hover';
    var trig = trigOf(kok);
    if (trig) trig.setAttribute('aria-expanded', 'true');
    acik = kok;
  }

  function kapat(kok, odakGeri) {
    if (!kok) return;
    var menu = menuOf(kok);
    if (menu) menu.setAttribute(OPEN, 'false');
    kok.setAttribute(OPEN, 'false');
    var trig = trigOf(kok);
    if (trig) {
      trig.setAttribute('aria-expanded', 'false');
      if (odakGeri) trig.focus();
    }
    kok._b2bNasil = null;
    if (acik === kok) acik = null;
  }

  document.addEventListener('pointerover', function (e) {
    if (!ince.matches) return;
    var kok = e.target.closest && e.target.closest('[data-b2b-cta]');
    // Menu artik body'de: uzerine gelince ACIK KALMALI.
    if (!kok && e.target.closest) {
      var m = e.target.closest('[data-b2b-cta-menu]');
      if (m && m._b2bKok) { clearTimeout(kapatmaZamani); return; }
    }
    if (!kok) return;
    hazirla(kok);
    ac(kok, 'hover');
  });

  document.addEventListener('pointerout', function (e) {
    if (!ince.matches || !acik) return;
    // ⚠️ TIKLA ACILAN MENU IMLEC CIKINCA KAPANMAZ. Kullanici
    // bilerek acti; imlecin gezinmesi onu kapatirsa secenege gitmek
    // icin gecen her hareket riskli olur. Kapanisi: disari tik, Esc,
    // ya da tetikleyiciye ikinci tik.
    if (acik._b2bNasil === 'click') return;
    var ilgili = e.relatedTarget;
    if (icinde(acik, ilgili)) return;
    // ⚠️ Kucuk gecikme: butondan menuye giderken imlec aradaki
    // bosluktan gecebiliyor; gecikmesiz menu goz kirpip kapanir.
    clearTimeout(kapatmaZamani);
    var hedef = acik;
    kapatmaZamani = setTimeout(function () { kapat(hedef); }, 160);
  });

  document.addEventListener('click', function (e) {
    var trig = e.target.closest && e.target.closest('[data-b2b-cta-trigger]');
    if (trig) {
      var kok = trig.closest('[data-b2b-cta]');
      hazirla(kok);
      e.preventDefault();
      /* 🔴 KAPATMA KOSULU "acik mi" DEGIL, "TIKLA MI ACILDI".
       * Once yalnizca `data-open`'a bakiyordu; imlec zaten acmis
       * oldugu icin her tik kapatiyordu. */
      if (kok.getAttribute(OPEN) === 'true' && kok._b2bNasil === 'click') {
        kapat(kok);
      } else {
        ac(kok, 'click');
        if (e.detail === 0) {           // klavyeden geldiyse
          var ilk = menuOf(kok) && menuOf(kok).querySelector('a');
          if (ilk) ilk.focus();
        }
      }
      return;
    }
    // Disari tiklama — menu body'de oldugu icin AYRICA soruluyor.
    if (acik && !icinde(acik, e.target)) kapat(acik);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && acik) kapat(acik, true);
  });

  /* ==================================================================
   *  🔴 MENUDE mousedown'A preventDefault (01.09.2026)
   * ==================================================================
   *
   *  BELIRTI: HOVER ile acilan menude secenege tiklamak calismiyordu.
   *  TIKLA acilan menude calisiyordu.
   *
   *  OLCULEN OLAY SIRASI (taraycidan, yukleme sonrasi):
   *
   *    pointerdown  menu DOM'da: true | data-open: true | href saglam
   *    mousedown    hedef: SPAN       | menude mi: true
   *    data-open -> false             | aktif oge: BUTTON   <- KAPANDI
   *    mouseup      hedef: DIV.quantity-input | menude mi: false
   *    click        hedef: BODY              | menude mi: false
   *
   *  ⚠️ MENU DOM'DAN SILINMIYOR. `MutationObserver` HIC
   *  tetiklenmedi, `href` saglam, `defaultPrevented` false. Kapanan sey
   *  GORUNURLUK — "silinme" ile "odak" ayri teshis.
   *
   *  SEBEP: `mousedown` odagi tasiyor. Menu `<body>`'ye portalli
   *  oldugu icin sepet cekmecesinin ODAK TUZAGI odagi geri cekiyor;
   *  asagidaki `focusout` isleyicisi menuyu kapatiyor. `mousedown` ile
   *  `mouseup` FARKLI ogelere indigi icin tarayici `click` URETMIYOR
   *  — bagimiz hic tiklanmis olmuyor.
   *
   *  ⚠️ YAKALAMA (capture) ASAMASINDA. Kabarma asamasinda dinlemek
   *  gec kalir: odak zaten tasinmis olur.
   *
   *  ⚠️ `focusout` ISLEYICISI DEGISMEDI. `preventDefault` yalnizca
   *  `mousedown`da; Tab ile gezinme, Enter ve Esc davranisi AYNI kalir.
   *  Orayi gevsetmek klavye yolunu bozardi.
   */
  document.addEventListener('mousedown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[data-b2b-cta-menu]')) return;
    // Odak HIC tasinmasin -> focusout tetiklenmesin -> menu acik kalsin
    // -> mousedown ve mouseup ayni ogeye insin -> tarayici click uretsin.
    e.preventDefault();
  }, true);

  document.addEventListener('focusout', function () {
    if (!acik) return;
    setTimeout(function () {
      if (acik && !icinde(acik, document.activeElement)) kapat(acik);
    }, 0);
  });

  /* ==================================================================
   *  🔴 OKSUZ MENU TEMIZLIGI (01.09.2026)
   * ==================================================================
   *  Menu `<body>`'ye tasindigi icin tetikleyicisi silindiginde GERIDE
   *  KALIYOR. Olculdu: sepet cekmecesi icerigini yeniden ciziyor,
   *  `.quick-cart [data-b2b-cta]` DOM'dan tamamen kayboluyor, portal
   *  menusu `<body>`'de OLU bir koke bagli duruyor.
   *
   *  ⚠️ YENIDEN CIZIM TEK YERDE DEGIL. Sepet cekmecesi, varyant
   *  degisimi, filtre uygulama, sonsuz kaydirma — hepsi ayni sinif.
   *  Bu yuzden yuzey yuzey listelenmiyor: DOM'dan dugum silinmesini
   *  izleyip OKSUZ KALAN her menu kaldiriliyor. Yeni bir yuzey
   *  eklendiginde de kendiliginden kapsaniyor.
   *
   *  ⚠️ Menuler zaten BIRIKIYORDU: `hazirla()` her tetikleyici icin
   *  bir menu portalliyor ve hicbir zaman kaldirmiyordu. 29 kartlik bir
   *  sayfada gezinen kullanici `<body>`'de 29 olu menu birakiyordu.
   *
   *  ⚠️ Gozlemci COK SIK tetikleniyor — is bir sonraki kareye
   *  erteleniyor ve yalnizca SILINME olan partilerde calisiyor.
   */
  var temizlikBekliyor = false;

  function oksuzleriKaldir() {
    temizlikBekliyor = false;
    var menuler = document.querySelectorAll('body > [data-b2b-cta-menu]');
    for (var i = 0; i < menuler.length; i += 1) {
      var m = menuler[i];
      var kok = m._b2bKok;
      if (kok && document.documentElement.contains(kok)) continue;
      // Kok gitti — menu de gitsin.
      if (acik === kok) acik = null;
      if (kok) kok._b2bMenu = null;
      m.remove();
    }
  }

  new MutationObserver(function (kayitlar) {
    if (temizlikBekliyor) return;
    for (var i = 0; i < kayitlar.length; i += 1) {
      if (kayitlar[i].removedNodes && kayitlar[i].removedNodes.length) {
        temizlikBekliyor = true;
        requestAnimationFrame(oksuzleriKaldir);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* 🔴 IC KAYDIRMA DA IZLENIYOR (01.09.2026).
   *
   * `scroll` BUBBLE ETMEZ — ama YAKALAMA (capture) evresinde
   * `window` -> `document` -> ... -> hedef yolunu izler. Bu yuzden
   * `document` uzerinde `capture: true` dinleyici, HANGI eleman
   * kayarsa kaysin haber aliyor. Kabin kendisine dinleyici baglamak
   * alternatifti ama cekmece yeniden cizildiginde o eleman
   * degisiyor ve dinleyici sessizce olu kalirdi.
   *
   * ⚠️ `window` DINLEYICISI DE KALIYOR. Belge kaydirmasinda ikisi
   * de tetiklenip ayni kareyi iki kez hesaplamasin diye asagidaki
   * rAF bekcisi var; kaldirmak yerine BIRLESTIRMEK dogru — window
   * yolu olculdu ve calisiyor, onu sokmenin gerekcesi yok.
   *
   * ⚠️ rAF BEKCISI: kaydirma saniyede onlarca olay uretiyor;
   * her birinde `getBoundingClientRect` + stil yazmak gereksiz. Kare
   * basina bir kez yeterli ve gozle fark edilmiyor. */
  var bekleyen = false;
  var yeniden = function () {
    if (!acik || bekleyen) return;
    bekleyen = true;
    requestAnimationFrame(function () {
      bekleyen = false;
      if (acik) yerlestir(acik);
    });
  };
  window.addEventListener('scroll', yeniden, { passive: true });
  window.addEventListener('resize', yeniden);
  document.addEventListener('scroll', yeniden, { passive: true, capture: true });
}());
